import { ILaya } from "../../ILaya";
import { URL } from "../net/URL";
import { PAL } from "../platform/PlatformAdapters";
export class Browser {
    static createElement(tagName) {
        return PAL.browser.createElement(tagName);
    }
    static getElementById(id) {
        return PAL.browser.getElementById(id);
    }
    static removeElement(ele) {
        PAL.browser.removeElement(ele);
    }
    static now() {
        return performance.now();
    }
    static get clientWidth() {
        if (this._clientWidth != null)
            return this._clientWidth;
        else
            return PAL.browser.getClientWidth();
    }
    static set clientWidth(value) {
        Browser._clientWidth = value;
    }
    static get clientHeight() {
        if (this._clientHeight != null)
            return this._clientHeight;
        else
            return PAL.browser.getClientHeight();
    }
    static set clientHeight(value) {
        Browser._clientHeight = value;
    }
    static get width() {
        return ((ILaya.stage && ILaya.stage.canvasRotation) ? Browser.clientHeight : Browser.clientWidth) * Browser.pixelRatio;
    }
    static get height() {
        return ((ILaya.stage && ILaya.stage.canvasRotation) ? Browser.clientWidth : Browser.clientHeight) * Browser.pixelRatio;
    }
    static get pixelRatio() {
        return PAL.browser.getPixelRatio();
    }
    static get container() {
        return Browser.mainCanvas.source.parentElement || document.body;
    }
    static getQueryString(name) {
        if (!Browser.window.location || !Browser.window.location.search)
            return null;
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = Browser.window.location.search.substring(1).match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    }
    static loadLib(src, async) {
        return new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.onload = function () {
                resolve();
            };
            script.onerror = function () {
                reject(`load ${src} failed`);
            };
            if (async != null)
                script.async = async;
            script.src = URL.postFormatURL(URL.formatURL(src));
            Browser.document.body.appendChild(script);
        });
    }
}
Browser.platform = 0;
Browser.platformName = "";
Browser.PLATFORM_PC = 0;
Browser.PLATFORM_ANDROID = 1;
Browser.PLATFORM_IOS = 2;
Browser.isDomSupported = true;
Browser.systemVersion = "";
Browser.SDKVersion = "";
Browser.bundles = new Map();
Browser.window = typeof window !== 'undefined' ? window : null;
Browser.document = typeof document !== 'undefined' ? document : null;
let win = window;
win.__getBundle_ = function (bundleId) {
    let bun = Browser.bundles.get(bundleId);
    if (!bun)
        Browser.bundles.set(bundleId, bun = {});
    return bun;
};
win.__setBundle_ = function (bundleId, bun, globalName) {
    let existing = Browser.bundles.get(bundleId);
    if (existing)
        copyProps(existing, bun, "default");
    Browser.bundles.set(bundleId, bun);
    if (globalName)
        win[globalName] = bun;
};
function copyProps(to, from, except) {
    var desc;
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of Object.getOwnPropertyNames(from))
            if (!to.hasOwnProperty(key) && key !== except)
                Object.defineProperty(to, key, { get: () => from[key], enumerable: !(desc = Object.getOwnPropertyDescriptor(from, key)) || desc.enumerable });
    }
    return to;
}
